<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCBackgroundVideo video="test-loop.mp4" />
    <FCCopy :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <p>The exterior construction consists of hundreds of aluminum fins, each embedded with LEDs creating an immense display on the outside of the building. The result is more than 2.7 miles of LED capable of showing graphics, logos, and messaging, in addition to creating beautiful displays of color and light.</p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
import FCBackgroundVideo from "@/components/patterns/FCBackgroundVideo";
export default {
  components: {
    FCCopy,
    FCBackgroundVideo
  },
  mounted() {
    const ref = this.$store.state.menu.westEndStadium.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.westEndStadium.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.westEndStadium.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "About West End Stadium",
      h3: "Exterior LED"
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-pitch-intro.jpg");
  background-size: cover;
  background-position: center;
}
.fcc-copy {
  //background: none;
}
</style>